<template>
    <div class="flat-view">
        <amf-form title="MyPlanConnect Carriers" class="container" :menu-items="['Add Carrier']">
            <div v-if="busy">Loading...</div>
            <div v-else-if="carriers.length == 0">No Carriers Found</div>
            <div v-if="!busy" class="container">
                <v-client-table :data="carriers" :columns="['name', 'portalUrl', 'isIntegrated']"
                    :options="tableOptions">
                    <template v-slot:name="{ row }">
                        <a href="#" @click.prevent="editCarrier(row)">{{ row.name }}</a>
                    </template>
                    <template v-slot:portalUrl="{ row }">{{ row.portalUrl }}</template>
                    <template v-slot:isIntegrated="{ row }">{{ row.isIntegrated ? 'Yes' : 'No' }}</template>
                </v-client-table>
            </div>
        </amf-form>
    </div>
</template>

<script>
    import Vue from 'vue';
import { modalService } from '../framework/utils/modal-service';
import { romeApi } from '../framework/utils/rome-api';

    export default {
        data() {
            return {
                carriers: [],
                tableOptions :{
                    ...utils.getVueTablesOptions(),
                    skin: 'table table-bordered table-condensed table-striped',
                    pagination: {
                        chunk: 1000,
                        dropdown: false
                    },
                    perPageValues: [],
                    perPage: 500,
                    texts: {
                        filter: null,
                        count: ''
                    },
                    headings: {
                        name: 'Name',
                        portalUrl: 'Portal Url',
                        isIntegrated: 'Is Integrated'
                    }
                }
            }
        },
        async created() {
            this.load();
        },
        methods: {
            async load() {
                this.busy = true;
                this.carriers = await romeApi.get('myplanconnect/carrier');
                this.busy = false;
            },
            async addCarrier() {
                let result = await modalService.show('carrier-editor', carrierEditor);
                if(result) this.load();
            },
            async editCarrier(carrier) {
                let result = await modalService.show('carrier-editor', carrierEditor, { carrier });
                if(result) this.load();
            }
        }
    }

    var carrierEditor = Vue.component('carrier-editor', {
        template:
        `<div>   
            <div class="row">
                <amf-input label="Name" v-model="name" :validator="$v.name" :columns="2" />
            </div>
            <div class="row">
                <amf-input label="Portal Url" v-model="portalUrl" :columns="2" />
                <amf-checkbox label="Is Integrated" v-model="isIntegrated" />
            </div>
            <div v-if="count > 0" class="row">
                <div class="col-md-12">
                    Usage Count: {{ count }}
                </div>
            </div>
        </div>`,
        props: ['carrier'],
        data() {
            return {
                count: 0,
                carrierId: null,
                name: null,
                portalUrl: null,
                isIntegrated: null,
            }
        },
        computed: {
            title() {
                return this.carrierId ? 'Edit Carrier' : 'Add Carrier'
            },
            buttonsCustom() {
                return this.carrierId && this.count == 0 ? "!Delete" : "";
            }
        },
        async created() {
            if(this.carrier) {
                _.assign(this.$data, this.carrier);
                this.count = await romeApi.get(`myplanconnect/carrier/${this.carrierId}/count`);
            }
        },
        validations() {
            return {
                name: v.build(v.required())
            }
        },
        methods: {
            async save() {
                let dto = {
                    carrierId: this.carrierId || 0,
                    name: this.name,
                    isIntegrated: this.isIntegrated || false,
                    portalUrl: this.portalUrl,
                    disablePreview: this.disablePreview || false
                }

                if(dto.carrierId) {
                    await romeApi.post(`myplanconnect/carrier/${dto.carrierId}`, dto);
                }
                else {
                    await romeApi.post('myplanconnect/carrier', dto);
                }
                
                return true;
            },
            async delete() {
                let confirmed = await modalService.confirm('Are you sure you want to delete this carrier?');
                if(confirmed) {
                    await romeApi.delete(`myplanconnect/carrier/${this.carrierId}`);
                    return true;
                }
                
                return false;
            }
        },
    });
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/shared/MyPlanConnectCarriers.vue